import { useForm } from 'react-hook-form'
import { Button, FormLabel, FormControl } from '@chakra-ui/react'
import { Row, Rows } from '@/components/rows'
import { Input } from '@/components/input'

type Props = {
  onSubmit: (input: FormValues) => Promise<void> | void
  defaultValues?: Partial<FormValues>
}

export type FormValues = {
  issueDate: string
  dueDate: string
  fee: number
}

export function CollectionNoticeForm({ defaultValues, onSubmit }: Props) {
  const { register, handleSubmit } = useForm<FormValues>({
    defaultValues,
  })

  return (
    <form id="invoice-form" onSubmit={handleSubmit(onSubmit)}>
      <Rows>
        <Row>
          <FormControl isRequired>
            <FormLabel>Dato</FormLabel>
            <Input type="date" {...register('issueDate', { required: true })} />
          </FormControl>
        </Row>
        <Row>
          <FormControl isRequired>
            <FormLabel>Forfall</FormLabel>
            <Input type="date" {...register('dueDate', { required: true })} />
          </FormControl>
        </Row>
        <Row>
          <FormControl isRequired>
            <FormLabel>Avgift kr</FormLabel>
            <Input
              {...register('fee', { required: true, valueAsNumber: true })}
            />
          </FormControl>
        </Row>
      </Rows>
    </form>
  )
}
